import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import classnames from 'classnames';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import Button from '@/shared/components/Button';

import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from './documentTemplateMessages';

const createSearchFilter = search => {
  if (!search || typeof search !== 'string') return () => true;
  const value = search.toLowerCase();
  return p =>
    p.tag.toLowerCase().indexOf(value) >= 0 ||
    (p.description && p.description.toLowerCase().indexOf(value) >= 0);
};

class PlaceholdersModal extends Component {
  constructor(props) {
    super(props);
    const { templateType } = props;
    this.state = {
      templateType,
      placeholders: null,
      searchValue: '',
    };
  }

  componentDidMount() {
    this.retrievePlaceholders();
  }

  retrievePlaceholders = () => {
    const { intl } = this.props;
    const { templateType } = this.state;
    if (templateType === null) return;

    api.base.get(`${config.appUrls.api}/api/documentTemplate/Placeholders/${templateType}`).then(
      ({ data }) => {
        this.setState({
          placeholders: data.map(p => {
            const tag = `{${p}}`;
            const description = intl.formatMessage(listItemMsg('mailplaceholder', tag, ' '));
            return { tag, description };
          }),
        });
      },
      error => {
        handleHttpError(intl)(error);
        return error;
      },
    );
  };
  templateTypeChanged = templateType => {
    this.setState({ templateType }, this.retrievePlaceholders);
  };

  render() {
    const { templateType, placeholders, searchValue } = this.state;
    const { templateTypes, onClose, intl } = this.props;

    const filteredPlaceholders = !searchValue
      ? placeholders || []
      : (placeholders || []).filter(createSearchFilter(searchValue));

    return (
      <Modal show onHide={() => onClose(null)} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.PlaceholdersModalTitle} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable">
          <div className="form-horizontal">
            <div className="form-group">
              <label className="control-label col-sm-4">
                <FormattedMessage {...messages.TemplateType} />
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={templateType || ''}
                  onChange={e => this.templateTypeChanged(e.target.value)}
                >
                  {templateType === null && (
                    <option value="">{intl.formatMessage(messages.SelectTemplateType)}</option>
                  )}
                  {templateTypes.map(x => (
                    <option key={x.id} value={x.id}>
                      {x.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <label>
              <FormattedMessage {...messages.PlaceholdersModalInfo} />
            </label>
            {templateType !== null ? (
              <div className="form-group">
                <div className="col-sm-12">
                  <input
                    type="text"
                    value={searchValue || ''}
                    className="form-control"
                    onChange={e => this.setState({ searchValue: e.target.value || '' })}
                    placeholder={intl.formatMessage(messages.Search)}
                  />
                </div>
              </div>
            ) : null}

            {placeholders &&
              filteredPlaceholders.map((p, i, a) => (
                <div
                  key={p.tag}
                  className={classnames('row', {
                    margin10B: a[i + 1] && a[i + 1].tag.charAt(1) !== p.tag.charAt(1),
                  })}
                >
                  <div className="col-md-6 break-word">{p.tag}</div>
                  <div className="col-md-6 break-word">{p.description}</div>
                </div>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose(null)}>
            <FormattedMessage {...messages.Close} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

PlaceholdersModal.propTypes = {
  intl: intlShape.isRequired,
  onClose: PropTypes.func.isRequired,
  templateTypes: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, label: PropTypes.string }),
  ).isRequired,

  templateType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PlaceholdersModal.defaultProps = {
  templateType: null,
};

export default injectIntl(PlaceholdersModal);
